import { render } from "./UnidadMedidaCreate.vue?vue&type=template&id=6db2f608&scoped=true"
import script from "./UnidadMedidaCreate.vue?vue&type=script&lang=js"
export * from "./UnidadMedidaCreate.vue?vue&type=script&lang=js"

import "./UnidadMedidaCreate.vue?vue&type=style&index=0&id=6db2f608&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db2f608"]])

export default __exports__